import { get } from 'lodash';

import { ASSET_TYPE, FIELD_PATHS, FIELD_VALUES, LIABILITY_TYPE } from '@funnels/constants';
import { AnyFormValues, Liability } from '@funnels/types';

export default function getAssetPurpose(formValues: AnyFormValues, assetIndex: number) {
  const propertyClientId = get(formValues, FIELD_PATHS.ASSET_CLIENT_ID(assetIndex));
  const toBeUsedAsSecurity = get(formValues, FIELD_PATHS.ASSET_USED_AS_SECURITY(assetIndex));
  const toBePurchased = get(formValues, FIELD_PATHS.ASSET_TO_BE_PURCHASED(assetIndex));
  const isProperty = get(formValues, FIELD_PATHS.ASSET_TYPE(assetIndex)) === ASSET_TYPE.PROPERTY;
  const liabilities: Liability[] = get(formValues, FIELD_PATHS.LIABILITIES(), []);
  const propertyLiabilities = liabilities.filter((_, index) =>
    (get({ liabilities }, FIELD_PATHS.LIABILITY_ASSET_CLIENT_ID(index), []) as string[]).includes(propertyClientId)
  );

  const hasLoanForClearing = propertyLiabilities.some(
    (_, index) =>
      get({ liabilities: propertyLiabilities }, FIELD_PATHS.LIABILITY_TYPE(index)) === LIABILITY_TYPE.HOME_LOAN &&
      !!get({ liabilities: propertyLiabilities }, FIELD_PATHS.LIABILITY_CLEARING_FROM_THIS_LOAN(index))
  );

  let assetPurpose;
  if (isProperty && toBeUsedAsSecurity && toBePurchased) {
    assetPurpose = FIELD_VALUES.NEW_PURCHASE;
  } else if (isProperty && toBeUsedAsSecurity && toBePurchased === false && hasLoanForClearing) {
    assetPurpose = FIELD_VALUES.REFINANCE;
  } else if (
    isProperty &&
    toBeUsedAsSecurity &&
    toBePurchased === false &&
    (!propertyLiabilities.length || !hasLoanForClearing)
  ) {
    assetPurpose = FIELD_VALUES.SECURITY_PROPERTY;
  } else if (toBeUsedAsSecurity === false && toBePurchased === false) {
    assetPurpose = FIELD_VALUES.OTHER;
  }

  return assetPurpose;
}
